import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

export const fetchSubscription = () => {
  return Api(endPoints.fetchSubscription, null, requestType.GET);
};

export const fetchBusinessSubscriptionHistory = (id) => {
  return Api(
    `${endPoints.fetchBusinessSubscriptionHistory}/${id}`,
    null,
    requestType.GET
  );
};

export const createUserSubscription = (params) => {
  return Api(endPoints.userSubscription, params, requestType.POST);
};
